import React from 'react';

import CustomTable from '../../../components/CustomTable';

import './styles.css'

export default function ResultList(props) {
    return (
        <CustomTable
            className={'table-reporte-registro-compra'}
            pagination={props.pagination}
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPdfRegistrado={props.loadingPdfRegistrado}
            loadingPLE={props.loadingPLE}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onExportPLE={props.onExportPLE}
            onExportPdfRegistrado={props.onExportPdfRegistrado}
            onPrint={props.onPrint}
            onChange={props.onChange}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Número correlativo del registro o código unico de la operación',
                    dataIndex: 'codigoUnico',
                    key: 'codigoUnico',
                    sorter: true,
            
                },
                {
                    title: 'Fecha de emisión del comprobante de pago o documento',
                    dataIndex: 'fechaEmisionStr',
                    key: 'fechaEmisionStr',
                    sorter: true
                },
                {
                    title: 'Fecha de vencimiento y/o pago',
                    dataIndex: 'fechaVencimientoStr',
                    key: 'fechaVencimientoStr',
                    sorter: true
                },
                {
                    title: 'Comprobante de pago o documento',
                    className: 'parent-group',
                    children: [
                        {
                            title: 'Tipo(10)',
                            dataIndex: 'tipo',
                            key: 'tipo',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Serie o codigo de la dependencia aduanera ',
                            dataIndex: 'serie',
                            key: 'serie',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Año de emisión de DUA o DSI',
                            dataIndex: 'numeroCorrelativo',
                            key: 'numeroCorrelativo',
                            className: 'child-group',
                            sorter: true
                        }
                    ]
                },
                {
                    title: 'N° del comprobante de pago,documento,N° de orden del formulario físico o virtual,N° de DUA,DSI o liquidación de cobranza u otros documentos emitidos por sunat para acreditar el crédito fiscal en la importación',
                    dataIndex: 'numero',
                    key: 'numero',
                    sorter: true,
                    //width: '100',
                },

                {
                    title: 'Información del Proveedor',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Tipo tabla(02)',
                            dataIndex: 'tipoDocumento',
                            key: 'tipoDocumento',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Número',
                            dataIndex: 'ruc',
                            key: 'ruc',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Apellidos y nombres denominación o razón social',
                            dataIndex: 'razonSocial',
                            key: 'razonSocial',
                            className: 'child-group child-group-2',
                            sorter: true,
                            render: (value) => (
                                <div style={{ minWidth: "300px" }}>{value}</div>
                            )
                        }
                    ]
                },
                {
                    title: 'Adquisiciones gravadas destinadas a operaciones gravadas y/o de exportación',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Base Imponible',
                            dataIndex: 'baseImponibleStr',
                            key: 'baseImponibleStr',
                            align: 'right',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'IGV',
                            dataIndex: 'igvStr',
                            key: 'igvStr',
                            align: 'right',
                            className: 'child-group child-group-2',
                            sorter: true
                        }
                    ]
                },
                {
                    title: 'Adquisiciones gravadas destinadas a operaciones gravadas y/o de exportación y/a operaciones no gravadas',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Base Imponible',
                            dataIndex: 'baseImponibleIVAPStr',
                            key: 'baseImponibleIVAPStr',
                            align: 'right',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'IVAP',
                            dataIndex: 'impuestoIVAPStr',
                            key: 'impuestoIVAPStr',
                            align: 'right',
                            className: 'child-group child-group-2',
                            sorter: true
                        }
                    ]
                },
                {
                    title: 'Adquisiciones gravadas destinadas a operaciones no gravadas',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Base Imponible',
                            dataIndex: 'baseImponibleIVAPStr',
                            key: 'baseImponibleIVAPStr',
                            align: 'right',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'IGV',
                            dataIndex: 'impuestoIVAPStr',
                            key: 'impuestoIVAPStr',
                            align: 'right',
                            className: 'child-group child-group-2',
                            sorter: true
                        }
                    ]
                },
                {
                    title: 'Valor de las adquisiciones no gravadas',
                    dataIndex: 'valorNoGrabadas',
                    key: 'igvStr',
                    align: 'right',
                    sorter: true
                },

                {
                    title: 'ISC',
                    dataIndex: 'iscStr',
                    key: 'iscStr',
                    align: 'right',
                    sorter: true
                },
       
                {
                    title: 'Otros tributos y cargos',
                    dataIndex: 'icbperStr',
                    key: 'icbperStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Importe total',
                    dataIndex: 'totalStr',
                    key: 'totalStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'N° de comprobante de pago emitido por sujeto no domiciliado',
                    dataIndex: 'otrosTributosStr',
                    key: 'otrosTributosStr',
                    align: 'right',
                    sorter: true
                },
           

                {
                    title: 'Constancia de depósito de detracción',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Número',
                            dataIndex: 'nroDeposito',
                            key: 'nroDeposito',
                            align: 'right',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Fecha de emisión',
                            dataIndex: 'fechaDeposito',
                            key: 'fechaDeposito',
                            align: 'right',
                            className: 'child-group child-group-2',
                            sorter: true
                        }
                    ]
                },
                {
                    title: 'Tipo de cambio',
                    dataIndex: 'tipoCambioStr',
                    key: 'tipoCambioStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Referencia del comprobante de pago o documento original que se modifica',
                    className: 'parent-group',
                    children: [
                        {
                            title: 'Fecha',
                            dataIndex: 'fechaReferencia',
                            key: 'fechaReferencia',
                            align: 'center',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Tipo (Tabla 10)',
                            dataIndex: 'tipoReferencia',
                            key: 'tipoReferencia',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Serie',
                            dataIndex: 'serieReferencia',
                            key: 'serieReferencia',
                            className: 'child-group',
                            sorter: true
                        },
                        {
                            title: 'Nº del comprobante de pago o documento',
                            dataIndex: 'comprobantePagoReferencia',
                            key: 'comprobantePagoReferencia',
                            className: 'child-group',
                            sorter: true
                        }
                    ]
                }
            ]}


        />
    );
}